import { motion, AnimatePresence } from 'framer-motion';
import { useState } from 'react';
import { useAllprojectsQuery } from '../../../helpers/projectsApi';
import Loader from '../../../components/Loader/Loader';
import { Pagination } from '@mui/material';


const Feature = () => {

    const [isHover, setIsHover] = useState('')

    const [page, setpage] = useState(1)
    const { data, isFetching } = useAllprojectsQuery({ page })

    return (
        <div className=' main-class max-w-screen-xl w-[90%] mx-auto md:w-full  min-h-[77vh] '>
            <h1 className='text-base md:text-2xl text-center font-bold dark:text-white'>Feature <span className='text-red-500'>Projetcs</span></h1>

            <h6
                className='text-center text-gray-600 dark:text-gray-400 mt-1 text-[14px] md:text-xs max-w-[700px] mx-auto'
            >
                Learn how entrepreneurs, businesses, and technology leaders who are after software-driven innovation are collaborating with our high-performing teams.
            </h6>
            {isFetching ? <Loader text='Loading projects...' height={'50vh'} /> : (

                <motion.div
                    whileInView={{ opacity: [0, 1], scale: [0.8, 1] }}
                    transition={{ duration: 1.0, delay: 0.2 }}
                    viewport={{ once: true }}
                    initial='hidden'
                    style={{ opacity: 0 }}
                >
                    <div className='grid grid-cols-1 gap-5 my-5 md:my-10  md:grid-cols-2 lg:grid-cols-3'>
                        {data.projects.length > 0 && data.projects.map((item, i) => (
                            <div
                                key={i}
                                onMouseEnter={() => setIsHover(item.title)}
                                onMouseLeave={() => setIsHover('')}
                                className='rounded-xl cursor-pointer h-[200px] md:h-[300px] relative hover:scale-105 duration-700 bg-white shadow-lg hover:shadow-xl'
                            >
                                <img src={item.img[0]} alt="img" className="w-full h-full rounded-xl" />

                                <AnimatePresence>
                                    {isHover && isHover === item.title && (
                                        <div>
                                            <div className='absolute inset-0 bg-black opacity-80 rounded-xl transition-all duration-700' />
                                            <motion.div
                                                initial={{ opacity: 0, y: 50 }}
                                                animate={{ opacity: 1, y: 0 }}
                                                exit={{ opacity: 0, y: -50 }}
                                                transition={{ duration: 0.5 }}
                                            >
                                                <div className='absolute right-0 left-0 bottom-0'>
                                                    <div className='p-4'>
                                                        <div className='mt-2'>
                                                            <h1 className="font-bold text-white text-[15px] md:text-[21px] line-clamp-3">
                                                                {item.title}
                                                            </h1>
                                                            <p className='line-clamp-4 text-white text-[13px] md:text-[16px]'>
                                                                {item.shortDec}
                                                            </p>
                                                            <div className='flex justify-end mt-4'>
                                                                <button
                                                                    onClick={() => window.open(item.link)}
                                                                    className="rounded-xl px-4 py-1 overflow-hidden relative group cursor-pointer border-2 font-semibold text-[13px] md:text-[15px] border-yellow-500 text-black ">
                                                                    <span className="absolute w-64 h-0 transition-all duration-700 origin-center rotate-45 -translate-x-20 bg-yellow-500 top-1/2 group-hover:h-64 group-hover:-translate-y-32 ease"></span>
                                                                    <span className="relative text-white transition duration-700 ease">Visit Project</span>
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </motion.div>
                                        </div>
                                    )}
                                </AnimatePresence>
                            </div>
                        ))}
                    </div>
                </motion.div>
            )}
            <div className='flex justify-center my-3'>
                {data && data.resultPerPage < data.filteredProjectsCount && (

                    <Pagination color='primary' size='medium'
                        count={Math.ceil(data.totalProjectsCount / data.resultPerPage)}
                        page={page}
                        shape='rounded'
                        onChange={(event, value) => setpage(value)}
                        showLastButton showFirstButton hideNextButton hidePrevButton
                        onClick={() => window.scrollTo(0, 0)}

                    />
                )}
            </div>
        </div>
    )
}

export default Feature
